import Net from '../core/libs/Net';

import { TWebAuthenticateRequest, TWebAuthenticateStatusResponse } from 'TProtocol/authentication/messages';

const authenticateWithMobileApp = (phoneNumber: string, authId: string): Promise<TWebAuthenticateStatusResponse> => {
  const request = new TWebAuthenticateRequest({
    phoneNumber,
    authRequestId: authId
  });

  const client = Net.createAuthService();
  return client.sendWebAuthRequest(request);
};

export const AuthenticationApi = {
  authenticateWithMobileApp
};
